// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  document.querySelector('.product-form__cart-submit').setAttribute('type', 'submit');
  document.querySelector('.product-form__cart-submit').classList.remove('variant-selector-form');
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// Helper function to make XHR requests (copied from theme.js)
function makeRequest(method, url) {
  return new Promise(function (resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else {
        reject(new Error(this.status));
      }
    };
    xhr.onerror = function () {
      reject(new Error(this.status));
    };
    xhr.send();
  });
}

// Helper function to update HTML content (copied from theme.js)
function updateInnerHTML(selector, doc) {
  const updatedItem = document.querySelector(selector, doc);
  const oldItem = document.querySelector(selector);
  if (updatedItem && oldItem) {
    oldItem.innerHTML = updatedItem.innerHTML;
  }
}

// Variant Selector Popup Handler
document.addEventListener('DOMContentLoaded', function() {
  // Selectors
  const variantSelectorPopup = document.querySelector('[data-variant-selector-popup]');
  const variantSelectorOverlay = document.querySelector('[data-variant-selector-overlay]');
  const variantSelectorClose = document.querySelector('[data-variant-selector-close]');
  const variantSelectorAddToCartBtn = document.querySelector('[data-variant-selector-add-to-cart]');
  const popupVariantSelects = document.querySelectorAll('[data-popup-variant-select]');
  const popupOptionButtons = document.querySelectorAll('[data-popup-option-button]');
  const popupForm = document.querySelector('[data-variant-popup-form]');
  const popupVariantIdInput = document.querySelector('[data-variant-popup-id]');
  const popupQuantityInput = document.querySelector('[data-popup-quantity]');
  const popupQuantityDecrease = document.querySelector('[data-popup-quantity-decrease]');
  const popupQuantityIncrease = document.querySelector('[data-popup-quantity-increase]');
  const popupImage = document.querySelector('[data-variant-popup-image]');
  const popupPrice = document.querySelector('[data-variant-popup-price]');
  const popupComparePrice = document.querySelector('[data-variant-popup-compare-price]');
  const goToCartBtn = document.querySelector('[data-go-to-cart]');
  
  if (!variantSelectorPopup) return;
  
  console.log('Popup found, initializing variant selector...');
  
  // Function to close the popup with animation
  function closeVariantPopup() {
    // First transform the content to slide down
    const popupContent = variantSelectorPopup.querySelector('.variant-selector-popup__content');
    if (popupContent) {
      popupContent.style.transform = 'translateY(100%)';
    }
    
    // After animation completes, remove active class
    setTimeout(() => {
      variantSelectorPopup.classList.remove('active');
    }, 300); // Match the transition time in CSS (0.3s)
  }
  
  // Close popup when clicking on overlay or close button
  if (variantSelectorOverlay) {
    variantSelectorOverlay.addEventListener('click', function(e) {
      e.preventDefault();
      closeVariantPopup();
    });
  }
  
  if (variantSelectorClose) {
    variantSelectorClose.addEventListener('click', function(e) {
      e.preventDefault();
      closeVariantPopup();
    });
  }
  
  // Close popup when pressing ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && variantSelectorPopup.classList.contains('active')) {
      closeVariantPopup();
    }
  });
  
  // Get product variant data
  let variantData = [];
  try {
    const variantJson = document.querySelector('[data-variant-popup-json]');
    if (variantJson) {
      variantData = JSON.parse(variantJson.textContent);
      console.log('Loaded variant data:', variantData.length, 'variants');
      
      // Process out of stock variants and mark buttons
      updateOutOfStockVariants(variantData);
      
      // If there's only one variant, set it immediately
      if (variantData.length === 1 && popupVariantIdInput) {
        console.log('Single variant product, setting variant ID:', variantData[0].id);
        popupVariantIdInput.value = variantData[0].id;
        
        // Enable add to cart button for single variant
        if (variantSelectorAddToCartBtn) {
          variantSelectorAddToCartBtn.disabled = false;
          variantSelectorAddToCartBtn.textContent = 'Add to Bag';
        }
      }
    } else {
      console.warn('No variant JSON data found');
    }
  } catch (e) {
    console.error('Error parsing variant data:', e);
  }
  
  // Update out of stock variant buttons
  function updateOutOfStockVariants(variants) {
    if (!variants || variants.length === 0) return;
    
    // Create a map of available option values for each option position
    const availableOptions = {};
    const optionPositions = [];
    
    // Find all option positions
    popupOptionButtons.forEach(button => {
      const optionPosition = button.getAttribute('data-option-name');
      if (optionPosition && !optionPositions.includes(optionPosition)) {
        optionPositions.push(optionPosition);
        availableOptions[optionPosition] = [];
      }
    });
    
    // Add available options from in-stock variants
    variants.forEach(variant => {
      if (variant.available && variant.options && Array.isArray(variant.options)) {
        variant.options.forEach((option, index) => {
          const optionPosition = `option${index + 1}`;
          if (!availableOptions[optionPosition]) {
            availableOptions[optionPosition] = [];
          }
          
          // Add to available options if not already included
          if (!availableOptions[optionPosition].includes(option)) {
            availableOptions[optionPosition].push(option);
          }
        });
      }
    });
    
    console.log('Available options map:', availableOptions);
    
    // Mark out of stock variant buttons
    popupOptionButtons.forEach(button => {
      const optionValue = button.getAttribute('data-option-value');
      const optionPosition = button.getAttribute('data-option-name');
      
      // Skip if inventory isn't tracked (all options are always available)
      const isInventoryTracked = variants.some(v => v.inventory_management === 'shopify');
      
      if (isInventoryTracked && optionValue && optionPosition) {
        // Check if this option value is in the available options
        const isAvailable = availableOptions[optionPosition] && 
                           availableOptions[optionPosition].includes(optionValue);
        
        // If not available, add the disabled class
        if (!isAvailable) {
          button.classList.add('disabled');
          button.setAttribute('title', `${optionValue} (Sold Out)`);
          button.setAttribute('aria-label', `${optionValue} (Sold Out)`);
        }
      }
    });
  }
  
  // Setup variant selector buttons
  const setupVariantSelectorButtons = () => {
    const variantSelectorButtons = document.querySelectorAll('.variant-selector-form');
    variantSelectorButtons.forEach(button => {
      // Make sure the button is type="button" to prevent form submission
      button.setAttribute('type', 'button');
    });
  };
  
  // Run setup
  setupVariantSelectorButtons();
  
  // Current product form reference
  let currentProductForm = null;
  
  // Open popup when clicking on .variant-selector-form elements
  document.addEventListener('click', function(e) {
    const target = e.target.classList.contains('variant-selector-form') ? 
                  e.target : 
                  e.target.closest('.variant-selector-form');
    
    if (target) {
      e.preventDefault();
      
      // Store reference to the product form
      currentProductForm = document.querySelector('form[data-product-form]');
      
      // If clicked from sticky bar and no form found, try the main product form
      if (!currentProductForm && target.closest('.sticky-atc-bar')) {
        currentProductForm = document.querySelector('.product form[data-product-form]');
      }
      
      // Check if product has variants
      const variantSelect = currentProductForm ? currentProductForm.querySelector('select[data-variant-select]') : null;
      const hasMultipleVariants = variantSelect && variantSelect.options.length > 1;
      
      // If product has no variants or only one variant, submit the form directly
      if (!hasMultipleVariants) {
        console.log('Product has no variants or only one variant, submitting form directly');
        
        // Change button type to submit and remove variant-selector-form class
        target.setAttribute('type', 'submit');
        target.classList.remove('variant-selector-form');
        
        // Trigger click to submit the form
        target.click();
        return;
      }
      
      // Prepare popup content before adding active class for animation
      const popupContent = variantSelectorPopup.querySelector('.variant-selector-popup__content');
      if (popupContent) {
        popupContent.style.transform = 'translateY(100%)';
      }
      
      // Show popup for products with multiple variants
      variantSelectorPopup.classList.add('active');
      
      // Force layout reflow before applying transform
      popupContent.offsetHeight;
      
      // Animate in with a slight delay for smoother animation
      setTimeout(() => {
        if (popupContent) {
          popupContent.style.transform = 'translateY(0)';
        }
      }, 10);
      
      // Reset quantity to 1
      if (popupQuantityInput) {
        popupQuantityInput.value = 1;
      }
      
      // Reset the variant selection UI
      resetVariantSelectionUI();
    }
  });
  
  // Reset the variant selection UI
  function resetVariantSelectionUI() {
    // Clear selected state from all option buttons
    popupOptionButtons.forEach(button => {
      if (!button.classList.contains('disabled')) {
        button.classList.remove('selected');
      }
    });
    
    // Reset dropdown selections
    popupVariantSelects.forEach(select => {
      select.selectedIndex = 0;
    });
    
    // Reset variant ID in form
    if (popupVariantIdInput) {
      popupVariantIdInput.value = '';
    }

    // Auto-select first available color variant
    setTimeout(() => {
      // Look for color option groups
      const colorOptions = Array.from(popupOptionButtons).filter(button => {
        const optionName = button.getAttribute('data-option-name');
        if (!optionName) return false;
        
        // Check if this button is part of a color swatch container
        const isColorSwatch = button.closest('.variant-selector-popup__color-swatches');
        if (isColorSwatch) return true;
        
        // Alternative check: look at the parent container to see if it has color in the class name
        const parentContainer = button.closest('.variant-selector-popup__option');
        if (parentContainer) {
          const label = parentContainer.querySelector('.product__label');
          if (label && (label.textContent.toLowerCase().includes('color') || 
                        label.textContent.toLowerCase().includes('colour'))) {
            return true;
          }
        }
        
        return false;
      });

      // Group by option name to get distinct color option groups
      const colorOptionGroups = {};
      colorOptions.forEach(button => {
        const optionName = button.getAttribute('data-option-name');
        if (!colorOptionGroups[optionName]) {
          colorOptionGroups[optionName] = [];
        }
        colorOptionGroups[optionName].push(button);
      });
      
      // For each color option group, select the first available option
      Object.values(colorOptionGroups).forEach(buttonGroup => {
        // Find first non-disabled button
        const firstAvailable = buttonGroup.find(button => !button.classList.contains('disabled'));
        if (firstAvailable) {
          // Simulate click on the first available color option
          firstAvailable.click();
          console.log('Auto-selected first available color variant:', firstAvailable.getAttribute('data-option-value'));
        }
      });
    }, 50);
    
    // Disable add to cart button
    if (variantSelectorAddToCartBtn) {
      variantSelectorAddToCartBtn.disabled = true;
      variantSelectorAddToCartBtn.textContent = 'Select variant';
      variantSelectorAddToCartBtn.style.opacity = '0.5';
    }
    
    // Reset the go to cart button
    if (goToCartBtn) {
      goToCartBtn.classList.add('hidden');
    }
    
    if (variantSelectorAddToCartBtn) {
      variantSelectorAddToCartBtn.classList.remove('hidden');
    }
  }
  
  // Handle form submission
  if (popupForm) {
    popupForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      // Check if a variant is selected
      const variantId = popupVariantIdInput?.value;
      if (!variantId) {
        console.error('No variant ID set');
        alert('Please select all options');
        return;
      }
      
      console.log('Adding to cart, variant ID:', variantId);
      
      // Get quantity
      const quantity = parseInt(popupQuantityInput?.value, 10) || 1;
      
      // Set button state immediately
      if (variantSelectorAddToCartBtn) {
        variantSelectorAddToCartBtn.disabled = true;
        variantSelectorAddToCartBtn.textContent = 'Adding...';
      }
      
      // Add to cart via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Added to cart:', data);
        
        // Show success message
        if (variantSelectorAddToCartBtn) {
          variantSelectorAddToCartBtn.classList.add('hidden');
        }
        
        if (goToCartBtn) {
          goToCartBtn.classList.remove('hidden');
          
          // Add event listener to go to cart button
          goToCartBtn.addEventListener('click', function(e) {
            // Close popup with animation first
            closeVariantPopup();
          });
        }
        
        // Get current cart to update proper theme cart count
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            // Update cart counts using the theme's data attribute
            const cartCounts = document.querySelectorAll('[data-js-cart-count]');
            cartCounts.forEach(element => {
              element.textContent = cart.item_count;
            });
            
            // Update cart count in the quick cart header
            const quickCartCount = document.querySelector('.quick-cart__heading sup');
            if (quickCartCount) {
              quickCartCount.textContent = cart.item_count;
            }
            
            // Trigger theme's cart:updated event for other components
            document.dispatchEvent(
              new CustomEvent('cart:updated', { detail: { cart: cart } })
            );
            
            // Refresh cart drawer contents
            refreshQuickCart();
            
            // Trigger cart:item-added event for other scripts
            document.dispatchEvent(new CustomEvent('cart:item-added', {
              detail: { product: data }
            }));
            
            // Trigger the theme's quick-cart:updated event
            document.dispatchEvent(new CustomEvent('quick-cart:updated'));
          })
          .catch(error => console.error('Error fetching cart data:', error));
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Show error
        if (variantSelectorAddToCartBtn) {
          variantSelectorAddToCartBtn.disabled = false;
          variantSelectorAddToCartBtn.textContent = 'Try Again';
        }
      });
    });
  }
  
  // Handle option button clicks
  popupOptionButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      // Stop event propagation to prevent theme's variant picker logic from firing
      e.stopPropagation();
      
      // Skip if button is disabled (out of stock)
      if (this.classList.contains('disabled')) {
        console.log('Clicked on out-of-stock variant, ignoring');
        return;
      }
      
      const optionValue = this.getAttribute('data-option-value');
      const optionIndex = this.getAttribute('data-option-index');
      const optionName = this.getAttribute('data-option-name');
      
      console.log('Button clicked:', optionValue, optionName);
      
      // Update the corresponding select dropdown but don't trigger change event
      const selectElement = document.querySelector(`[data-popup-variant-select][data-index="${optionName}"]`);
      if (selectElement) {
        console.log('Found select element:', selectElement.id);
        selectElement.value = optionValue;
        
        // Don't trigger the default select change event that would activate theme's logic
        // Instead of using dispatchEvent, we'll handle our own logic
      }
      
      // Update UI - mark this button as selected within its option group
      const optionButtons = document.querySelectorAll(`[data-popup-option-button][data-option-name="${optionName}"]`);
      optionButtons.forEach(btn => {
        btn.classList.remove('selected');
      });
      this.classList.add('selected');
      
      // Update the selected value display
      const displayElement = document.querySelector(`[data-selected-value-for-option][data-option-name="${optionName}"]`);
      if (displayElement) {
        displayElement.textContent = optionValue;
      }
      
      // Run our own variant selection logic
      setTimeout(() => {
        console.log('Running isolated variant selection logic');
        
        // Get all selected values from buttons directly
        const selectedOptions = [];
        const optionGroups = {};
        
        // Group buttons by option name to ensure we have one selection per option
        popupOptionButtons.forEach(btn => {
          const btnOptionName = btn.getAttribute('data-option-name');
          if (!optionGroups[btnOptionName]) {
            optionGroups[btnOptionName] = [];
          }
          if (btn.classList.contains('selected')) {
            optionGroups[btnOptionName].push(btn.getAttribute('data-option-value'));
          }
        });
        
        // Get the selected value for each option group
        Object.values(optionGroups).forEach(group => {
          if (group.length > 0) {
            selectedOptions.push(group[0]); // Take the first (should be only) selected option
          }
        });
        
        console.log('Collected selected options:', selectedOptions);
        console.log('Option groups:', Object.keys(optionGroups).length);
        
        // Check if we have a complete selection (one for each option)
        if (selectedOptions.length === Object.keys(optionGroups).length && selectedOptions.length > 0) {
          console.log('Complete variant selection, looking for matching variant');
          
          // Find matching variant directly without relying on select dropdowns
          const matchingVariant = findVariantByOptions(variantData, selectedOptions);
          console.log('Found matching variant:', matchingVariant);
          
          if (matchingVariant) {
            // Set the variant ID directly
            if (popupVariantIdInput) {
              popupVariantIdInput.value = matchingVariant.id;
              console.log('Set variant ID:', matchingVariant.id);

              // Save selection to localStorage
              localStorage.setItem('selectedVariantId', matchingVariant.id);
            }

            // Update default variant selector
            if (currentProductForm) {
              // Update default select dropdown
              const defaultSelect = currentProductForm.querySelector('select[data-variant-select]');
              if (defaultSelect) {
                defaultSelect.value = matchingVariant.id;
                // Trigger change event to update the theme's variant logic
                defaultSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }

              // Update default swatch/chip buttons
              selectedOptions.forEach((optionValue, index) => {
                const optionPosition = `option${index + 1}`;
                // Target both dynamic-variant-button and product__chip-button classes
                const defaultButtons = document.querySelectorAll(
                  `[data-index="${optionPosition}"] .dynamic-variant-button, 
                   [data-index="${optionPosition}"] .product__chip-button,
                   [data-option-position="${index + 1}"] button[data-value]`
                );
                
                defaultButtons.forEach(btn => {
                  const buttonValue = btn.getAttribute('data-value') || btn.getAttribute('data-option-value');
                  if (buttonValue === optionValue) {
                    btn.classList.add('selected');
                  } else {
                    btn.classList.remove('selected');
                  }
                });
              });
            }

            // Update add to cart button state based on availability
            if (variantSelectorAddToCartBtn) {
              if (matchingVariant.available) {
                variantSelectorAddToCartBtn.disabled = false;
                variantSelectorAddToCartBtn.textContent = 'Add to Bag';
                variantSelectorAddToCartBtn.style.opacity = '1';
                console.log('Enabled add to cart button');
              } else {
                variantSelectorAddToCartBtn.disabled = true;
                variantSelectorAddToCartBtn.textContent = 'Sold Out';
                variantSelectorAddToCartBtn.style.opacity = '0.5';
                console.log('Disabled add to cart button - sold out');
              }
            }
          }
        }
      }, 10);
    });
  });
  
  // Update selected variant based on current selections
  function updateSelectedVariant() {
    // Get all selected options
    const selectedOptions = [];
    popupVariantSelects.forEach(select => {
      if (select.value && select.value !== '') {
        selectedOptions.push(select.value);
      }
    });
    
    console.log('Selected options:', selectedOptions);
    console.log('Required options:', popupVariantSelects.length);
    
    // Check if we have any variant selects at all
    if (popupVariantSelects.length === 0) {
      // No variant options, enable the button
      if (variantSelectorAddToCartBtn) {
        variantSelectorAddToCartBtn.disabled = false;
        variantSelectorAddToCartBtn.textContent = 'Add to Bag';
        variantSelectorAddToCartBtn.style.opacity = '1';
      }
      return;
    }
    
    // Only proceed if all options are selected
    if (selectedOptions.length !== popupVariantSelects.length) {
      // Disable add to cart if not all options selected
      if (variantSelectorAddToCartBtn) {
        variantSelectorAddToCartBtn.disabled = true;
        variantSelectorAddToCartBtn.textContent = 'Select all options';
        variantSelectorAddToCartBtn.style.opacity = '0.5';
      }
      return;
    }
    
    console.log('All options selected, finding variant...');
    
    // Find matching variant
    const matchingVariant = findVariantByOptions(variantData, selectedOptions);
    console.log('Matching variant:', matchingVariant);
    
    // Force enable the button if we have a valid variant ID
    if (matchingVariant) {
      // Update form with variant ID
      if (popupVariantIdInput) {
        popupVariantIdInput.value = matchingVariant.id;
        console.log('Set variant ID:', matchingVariant.id);
      }
      
      // Always enable the button if a variant is selected
      if (variantSelectorAddToCartBtn) {
        // Force enable the button if variant is available
        if (matchingVariant.available) {
          variantSelectorAddToCartBtn.disabled = false;
          variantSelectorAddToCartBtn.textContent = 'Add to Bag';
          variantSelectorAddToCartBtn.style.opacity = '1';
        } else {
          variantSelectorAddToCartBtn.disabled = true;
          variantSelectorAddToCartBtn.textContent = 'Sold Out';
          variantSelectorAddToCartBtn.style.opacity = '0.5';
        }
        
        console.log('Button state updated:', !variantSelectorAddToCartBtn.disabled);
      }
      
      // Update image if variant has an image
      if (popupImage && matchingVariant.featured_image) {
        popupImage.src = matchingVariant.featured_image.src;
      }
      
      // Update prices
      if (popupPrice) {
        // Format price (basic formatting, you might need to adjust based on your currency)
        let formattedPrice = formatMoney(matchingVariant.price);
        popupPrice.textContent = formattedPrice;
      }
      
      if (popupComparePrice) {
        if (matchingVariant.compare_at_price > matchingVariant.price) {
          let formattedComparePrice = formatMoney(matchingVariant.compare_at_price);
          popupComparePrice.textContent = formattedComparePrice;
          popupComparePrice.classList.remove('hidden');
        } else {
          popupComparePrice.classList.add('hidden');
        }
      }
    } else {
      // No matching variant found
      if (variantSelectorAddToCartBtn) {
        variantSelectorAddToCartBtn.disabled = true;
        variantSelectorAddToCartBtn.textContent = 'Unavailable';
        variantSelectorAddToCartBtn.style.opacity = '0.5';
      }
    }
  }
  
  // Helper function to find variant by selected options
  function findVariantByOptions(variants, selectedOptions) {
    if (!variants || !Array.isArray(variants) || variants.length === 0) {
      console.error('No variants data available');
      return null;
    }
    
    // If only one option is available, return that variant
    if (variants.length === 1) {
      console.log('Only one variant available, using it');
      return variants[0];
    }

    // If there are variants but no selected options, use the first variant
    if (!selectedOptions || !Array.isArray(selectedOptions) || selectedOptions.length === 0) {
      console.log('No selected options, using first variant');
      return variants[0];
    }
    
    console.log('Looking for variant with options:', selectedOptions);
    
    // Get any variant that has all the selected options
    return variants.find(variant => {
      if (!variant.options || !Array.isArray(variant.options)) {
        return false;
      }
      
      // Compare each option with selected options
      return selectedOptions.every((selectedOption, index) => {
        if (index >= variant.options.length) {
          return false;
        }
        
        // Case-insensitive comparison to be safe
        return String(variant.options[index]).toLowerCase() === String(selectedOption).toLowerCase();
      });
    });
  }
  
  // Basic money formatter - adjust based on your currency format
  function formatMoney(cents) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    
    return formatter.format(cents / 100);
  }
  
  // Handle quantity changes
  if (popupQuantityDecrease) {
    popupQuantityDecrease.addEventListener('click', function() {
      const currentValue = parseInt(popupQuantityInput.value, 10) || 1;
      if (currentValue > 1) {
        popupQuantityInput.value = currentValue - 1;
      }
    });
  }
  
  if (popupQuantityIncrease) {
    popupQuantityIncrease.addEventListener('click', function() {
      const currentValue = parseInt(popupQuantityInput.value, 10) || 1;
      popupQuantityInput.value = currentValue + 1;
    });
  }
  
  // Function that handles the cart refresh using the theme's pattern
  function refreshQuickCart() {
    // Find the quick cart section ID
    const quickCart = document.querySelector('.quick-cart');
    if (!quickCart) {
      console.warn('Quick cart not found in the theme');
      return;
    }
    
    const sectionId = quickCart.getAttribute('data-section-id');
    if (!sectionId) {
      console.warn('Missing section ID on quick cart');
      return;
    }
    
    // Get the cart section using the theme's fetch approach
    const url = `/cart?section_id=${sectionId}`;
    
    makeRequest('GET', url).then(response => {
      // Create a container for the response
      const container = document.createElement('div');
      container.innerHTML = response;
      
      // Find elements to update
      const cartWrapper = document.querySelector('.quick-cart__wrapper');
      if (!cartWrapper) return;
      
      // Get selectors from the theme
      const items = '.quick-cart__items';
      const cartCount = '.quick-cart__heading sup';
      const subtotal = '.quick-cart__footer-subtotal span';
      const discounts = '.quick-cart__item-discounts';
      const innerContainer = '.quick-cart__container';
      
      // Get response components
      const responseInnerContainer = container.querySelector(innerContainer);
      
      // Update cart items and related elements
      const cartHasItems = Boolean(document.querySelector(items));
      const responseHasItems = Boolean(container.querySelector(items));
      
      console.log('Cart refresh - cart has items:', cartHasItems, 'response has items:', responseHasItems);
      
      // If the response has items but the current cart doesn't, or vice versa,
      // we need to replace the entire inner container
      if (responseHasItems !== cartHasItems) {
        console.log('Cart state changed (empty/not-empty), replacing entire container');
        const currentInnerContainer = document.querySelector(innerContainer);
        if (currentInnerContainer && responseInnerContainer) {
          currentInnerContainer.innerHTML = responseInnerContainer.innerHTML;
        }
      } else if (responseHasItems && cartHasItems) {
        // Both have items, update specific sections
        console.log('Updating cart items');
        
        // Update cart items
        const currentItems = document.querySelector(items);
        const newItems = container.querySelector(items);
        if (currentItems && newItems) {
          currentItems.innerHTML = newItems.innerHTML;
        }
        
        // Update cart count
        const currentCount = document.querySelector(cartCount);
        const newCount = container.querySelector(cartCount);
        if (currentCount && newCount) {
          currentCount.innerHTML = newCount.innerHTML;
        }
        
        // Update subtotal
        const currentSubtotal = document.querySelector(subtotal);
        const newSubtotal = container.querySelector(subtotal);
        if (currentSubtotal && newSubtotal) {
          currentSubtotal.innerHTML = newSubtotal.innerHTML;
        }
        
        // Update discounts if any
        const currentDiscounts = document.querySelector(discounts);
        const newDiscounts = container.querySelector(discounts);
        if (currentDiscounts && newDiscounts) {
          currentDiscounts.innerHTML = newDiscounts.innerHTML;
        }
      }
      
      // Open the quick cart
      document.dispatchEvent(new CustomEvent('quick-cart:open'));
    }).catch(error => {
      console.error('Error refreshing quick cart:', error);
    });
  }
  
  // Close popup when clicking overlay or close button
  if (variantSelectorOverlay) {
    variantSelectorOverlay.addEventListener('click', function() {
      variantSelectorPopup.classList.remove('active');
    });
  }
  
  if (variantSelectorClose) {
    variantSelectorClose.addEventListener('click', function() {
      variantSelectorPopup.classList.remove('active');
    });
  }
  
  // Close when clicking Go To Bag button
  if (goToCartBtn) {
    goToCartBtn.addEventListener('click', function() {
      variantSelectorPopup.classList.remove('active');
    });
  }
});

// Update add to cart buttons to "Go to Cart" after adding to cart
document.addEventListener('cart:item-added', function() {
  // Update all add to cart buttons to "Go to Cart"
  const addToCartButtons = document.querySelectorAll('.product-form__cart-submit, [data-add-to-cart]');
  addToCartButtons.forEach(button => {
    button.textContent = 'Go to Cart';
    button.classList.add('go-to-cart');
    button.classList.remove('variant-selector-form');
    const originalOnClick = button.onclick;
    button.onclick = function(e) {
      e.preventDefault();
      window.location.href = '/cart';
    };
  });
});

// Restore variant selection on page load
document.addEventListener('DOMContentLoaded', function() {
  const savedVariantId = localStorage.getItem('selectedVariantId');
  if (savedVariantId) {
    const defaultSelect = document.querySelector('select[data-variant-select]');
    if (defaultSelect) {
      defaultSelect.value = savedVariantId;
      defaultSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});